import React from 'react';
import { CheckCircle2, Truck } from 'lucide-react';
export function EBTWICBanner() {
  return <div className="bg-gradient-to-r from-[#948B7A] to-[#7d7465] text-white py-2 md:py-3 overflow-hidden" data-id="element-19">
      {/* Mobile: Scrolling marquee */}
      <div className="md:hidden" data-id="element-20">
        <div className="animate-marquee whitespace-nowrap flex items-center gap-6" data-id="element-21">
          <div className="flex items-center gap-1.5 bg-white/10 px-2.5 py-1 rounded-full" data-id="element-22">
            <CheckCircle2 className="w-3.5 h-3.5 text-[#edeae6] flex-shrink-0" data-id="element-23" />
            <span className="text-xs font-bold" data-id="element-24">EBT/SNAP Accepted</span>
          </div>
          <div className="flex items-center gap-1.5 bg-[#edeae6] text-[#948B7A] px-2.5 py-1 rounded-full" data-id="element-25">
            <CheckCircle2 className="w-3.5 h-3.5 flex-shrink-0" data-id="element-26" />
            <span className="text-xs font-bold" data-id="element-27">Free Delivery $35+</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-28">
            <Truck className="w-3.5 h-3.5 text-[#edeae6] flex-shrink-0" data-id="element-29" />
            <span className="text-xs font-semibold" data-id="element-30">
              Uber Eats • DoorDash • Instacart • GrubHub
            </span>
          </div>
          {/* Duplicate for seamless loop */}
          <div className="flex items-center gap-1.5 bg-white/10 px-2.5 py-1 rounded-full" data-id="element-31">
            <CheckCircle2 className="w-3.5 h-3.5 text-[#edeae6] flex-shrink-0" data-id="element-32" />
            <span className="text-xs font-bold" data-id="element-33">EBT/SNAP Accepted</span>
          </div>
          <div className="flex items-center gap-1.5 bg-[#edeae6] text-[#948B7A] px-2.5 py-1 rounded-full" data-id="element-34">
            <CheckCircle2 className="w-3.5 h-3.5 flex-shrink-0" data-id="element-35" />
            <span className="text-xs font-bold" data-id="element-36">Free Delivery $35+</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-37">
            <Truck className="w-3.5 h-3.5 text-[#edeae6] flex-shrink-0" data-id="element-38" />
            <span className="text-xs font-semibold" data-id="element-39">
              Uber Eats • DoorDash • Instacart • GrubHub
            </span>
          </div>
        </div>
      </div>

      {/* Desktop: Static centered */}
      <div className="hidden md:block max-w-7xl mx-auto px-6" data-id="element-40">
        <div className="flex items-center justify-center gap-6 lg:gap-8 flex-wrap" data-id="element-41">
          <div className="flex items-center gap-2" data-id="element-42">
            <CheckCircle2 className="w-5 h-5 text-[#edeae6]" data-id="element-43" />
            <span className="text-sm font-semibold" data-id="element-44">WIC Approved</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-45">
            <CheckCircle2 className="w-5 h-5 text-[#edeae6]" data-id="element-46" />
            <span className="text-sm font-semibold" data-id="element-47">EBT/SNAP</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-48">
            <CheckCircle2 className="w-5 h-5 text-[#edeae6]" data-id="element-49" />
            <span className="text-sm font-semibold" data-id="element-50">USDA Partner</span>
          </div>
          <div className="flex items-center gap-2 bg-[#edeae6] text-[#948B7A] px-3 py-1.5 rounded-full" data-id="element-51">
            <CheckCircle2 className="w-5 h-5" data-id="element-52" />
            <span className="text-sm font-bold" data-id="element-53">Free Delivery Over $35</span>
          </div>
          <div className="h-4 w-px bg-white/20" data-id="element-54" />
          <div className="flex items-center gap-3" data-id="element-55">
            <Truck className="w-5 h-5 text-[#edeae6]" data-id="element-56" />
            <span className="text-sm font-semibold" data-id="element-57">Available on:</span>
            <div className="flex items-center gap-2 text-xs font-medium" data-id="element-58">
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-59">Uber Eats</span>
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-60">DoorDash</span>
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-61">Instacart</span>
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-62">GrubHub</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}